const iconPaths = {
  print: 'M6 8V3h12v5M6 17H3V9h18v8h-3M6 14h12v7H6zM17 11h1',
  box: 'm3 7 9-4 9 4v10l-9 4-9-4V7Zm0 0 9 4 9-4M12 11v10M7 5l10 4',
  mail: 'M3 5h18v14H3zM3 5l9 8 9-8',
  web: 'M3 4h18v14H3zM8 22h8M12 18v4M3 8h18',
  brand: 'M3 3h8l10 10-8 8L3 11V3ZM7 7h.01',
  support: 'M4 13v-2a8 8 0 0 1 16 0v2M4 11H2v7h4v-7H4ZM20 11h2v7h-4v-7h2ZM20 18v3h-8',
  local: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0ZM9 10a3 3 0 1 0 6 0 3 3 0 1 0-6 0',
  people: 'M9 11a4 4 0 1 0 0-8 4 4 0 1 0 0 8ZM2 21v-3a7 7 0 0 1 14 0v3M17 4a4 4 0 0 1 0 8M18 15a5 5 0 0 1 4 5',
} as const

export type AboutIconName = keyof typeof iconPaths

export function AboutIcon({ name }: { name: AboutIconName }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d={iconPaths[name]} /></svg>
}
